<template>
  <ul class="share">
    <li v-for="(item, index) in shareItems" :key="index" @click="item.emit(item.type)">
      <img :src="getIconPath(item.type)">
      <div>{{ item.title }}</div>
    </li>
  </ul>
</template>
<script>
import MgtvApi from 'MgtvApi';
import _ from 'lodash';


export default {
  props: ['shareContent', 'callback', 'useShareUrl'],
  data() {
    const {
      shareTo, refresh, copyTo, openInBrowser,
    } = this;
    return {
      shareItems: [{
        type: 'moments',
        title: '朋友圈',
        emit: shareTo,
      }, {
        type: 'wechat',
        title: '微信好友',
        emit: shareTo,
      }, {
        type: 'weibo',
        title: '新浪微博',
        emit: shareTo,
      }, {
        type: 'qq',
        title: 'QQ',
        emit: shareTo,
      }, {
        type: 'qzone',
        title: 'QQ空间',
        emit: shareTo,
      }, {
        type: 'refresh',
        title: '刷新',
        emit: refresh,
      }, {
        type: 'copy',
        title: '复制链接',
        emit: copyTo,
      }, {
        type: 'browser',
        title: '浏览器打开',
        emit: openInBrowser,
      }],
    };
  },
  methods: {
    getIconPath(type) {
      return `./img/share/${type}.png`;
    },
    refresh() {
      window.location.reload();
    },
    copyTo() {
      let { href } = window.location;
      if (this.useShareUrl) {
        href = this.shareContent.shareUrl;
      }
      MgtvApi.sendToClipboard({
        content: href,
      });
      this.$toast('复制成功');
    },
    openInBrowser() {
      let { href } = window.location;
      if (this.useShareUrl) {
        href = this.shareContent.shareUrl;
      }
      MgtvApi.openBrowser({
        url: href,
      });
    },
    shareTo(type) {
      MgtvApi.shareTo(_.assign({
        type, // 分享平台：wechat(微信好友), moments(微信朋友圈), weibo, qq, qzone, face2face, fantuan, sms
        style: '', // 分享类型  0(链接), 1(图片)
        title: '', // 分享标题
        shareUrl: '', // 分享链接（当style为1时，这里填写分享的图片地址）
        shareDesc: '', // 分享描述
        shareIcon: '', // 分享图标
      }, this.shareContent), (val) => {
        if (this.callback) {
          const { data: { value } } = val;
          if (Number(value) === 1) { // 分享成功
            this.callback();
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.share {
  width: 100%;
  padding: 30px 18px;
  box-sizing: border-box;
  overflow: hidden;

  li {
    &:nth-of-type(6), &:nth-of-type(7), &:nth-of-type(8), {
      margin-bottom: 0;
    }

    &:nth-of-type(6) {
      margin: 0;
    }

    margin-bottom: 20px;
    float: left;
    width: 114px;
    font-size: 20px;
    text-align: center;

    img {
      width: 114px;
      height: 114px;
    }

    & + li {
      margin-left: 36px;
    }

    flex-direction: column;

    div {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
